import { LoggedInProps } from "modules/common/components/routing/AnonymousRoute";
import { ProtectedRoute } from "modules/common/components/routing/ProtectedRoute";
import { routes } from "modules/common/routes";
import { can } from "modules/session/auth/access";
import { SessionType } from "modules/session/auth/models/session";
import { ScheduleStoreType } from "modules/spending/schedule/models/schedule-store";
import { TimesheetStoreType } from "modules/spending/timesheet/models/timesheet-store";
import { UnitEconomicsStoreType } from "modules/spending/unit-economics/models/unit-economics-store";
import { WorkloadPlanPage } from "modules/spending/workload-plan/components/WorkloadPlanPage";
import { WorkloadPlanStoreType } from "modules/spending/workload-plan/models/plan-store";
import React from "react";
import { Navigate, RouteObject } from "react-router";
import { ProjectPlanPage } from "./components/ProjectPlanPage";
import { SchedulesTabsPage } from "./components/SchedulesTabsPage";
import func from "./functionalities";
import { ProjectPlanStoreType } from "./models/project-plan-store";

export const buildRoutes = ({
    loggedIn,
    session,
    projectPlan,
    workloadPlan,
    timesheet,
    unit,
    schedule,
}: RoutesProps): RouteObject[] => {
    // Поиск общий для табельных экранов: набранное на одном экране остаётся
    // на остальных. Раздел сменился, а стор Табеля Плана — тот же самый.
    const setUserFilter = (value: string) => {
        timesheet.setQuery(value);
        workloadPlan.setQuery(value);
        unit.setQuery(value);
        schedule.setQuery(value);
    };

    return [
        // Табель План переехал сюда из «Управления организацией» — старые ссылки живут
        {
            path: routes.spending.workload,
            element: <Navigate to={routes.schedules.workload} replace={true} />,
        },
        // Клик по пункту меню «Графики» ведёт сюда — отправляем на первый
        // доступный по правам подпункт (как «Расходы» → «Накладные расходы»)
        {
            path: routes.schedules.path,
            element: <Navigate to={firstAvailableSchedulesRoute(session.access)} replace={true} />,
        },
        {
            path: `${routes.schedules.path}/*`,
            element: (
                <ProtectedRoute loggedIn={loggedIn}>
                    <SchedulesTabsPage
                        projectPlanPanel={
                            can(func.SCHEDULES_READ, session.access) ? <ProjectPlanPage store={projectPlan} access={session.access} /> : null
                        }
                        workloadPanel={
                            // смотреть может любой сотрудник, какие строки править — решает страница
                            can(func.SCHEDULES_READ, session.access) ? (
                                <WorkloadPlanPage
                                    store={workloadPlan}
                                    session={session}
                                    setUserFilter={setUserFilter}
                                />
                            ) : null
                        }
                    />
                </ProtectedRoute>
            ),
        },
    ];
};

/** Первый подпункт «Графиков»: оба открыты любому сотруднику, остальным — на главную */
const firstAvailableSchedulesRoute = (access: string[]) =>
    can(func.SCHEDULES_READ, access) ? routes.schedules.projectPlan : routes.main.path;

interface RoutesProps extends LoggedInProps {
    session: SessionType;
    projectPlan: ProjectPlanStoreType;
    workloadPlan: WorkloadPlanStoreType;
    timesheet: TimesheetStoreType;
    unit: UnitEconomicsStoreType;
    schedule: ScheduleStoreType;
}
